export default __webpack_public_path__ + "static/media/SamsungInterFace-ExtraBold.03ac00c7.otf";